<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'multi-drop-down',
  computed: {
    current: {
      get() {
        return this.modelValue;
      },
      set(value: number) {
        this.$emit('update:modelValue', value);
      },
    },
  },
  props: ['modelValue', 'options'],
});
</script>

<template>
  <MultiSelect
    display="chip"
    v-model="current"
    :options="options"
    optionLabel="Name"
    optionValue="Id"
    placeholder="Все"
  />
</template>

<style scoped lang="scss"></style>